import axios from "@/api/axiosInstance";
import {
  FetchCampaignStatusRequest,
  FetchCampaignStatusResponse,
} from "./types";

export const fetchCampaignStatus = async (
  requestParams: FetchCampaignStatusRequest = {},
): Promise<FetchCampaignStatusResponse> => {
  const response = await axios.get<FetchCampaignStatusResponse>(
    `/api/private/stochastic/campaign-status-data`,
    {
      params: requestParams,
    },
  );

  return response.data;
};
